var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectDetailPopulation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_14436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1688 17.5V15.8333C14.1688 14.9493 13.8176 14.1014 13.1925 13.4763C12.5674 12.8512 11.7195 12.5 10.8354 12.5H4.16878C3.28473 12.5 2.43688 12.8512 1.81176 13.4763C1.18664 14.1014 0.835449 14.9493 0.835449 15.8333V17.5",
    stroke: "#662D91",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50179 9.16667C9.34274 9.16667 10.8351 7.67428 10.8351 5.83333C10.8351 3.99238 9.34274 2.5 7.50179 2.5C5.66084 2.5 4.16846 3.99238 4.16846 5.83333C4.16846 7.67428 5.66084 9.16667 7.50179 9.16667Z",
    stroke: "#662D91",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1685 17.5001V15.8334C19.1679 15.0948 18.9221 14.3774 18.4696 13.7937C18.0171 13.2099 17.3836 12.793 16.6685 12.6084",
    stroke: "#662D91",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3354 2.6084C14.0525 2.79198 14.688 3.20898 15.1418 3.79366C15.5956 4.37833 15.842 5.09742 15.842 5.83757C15.842 6.57771 15.5956 7.2968 15.1418 7.88147C14.688 8.46615 14.0525 8.88315 13.3354 9.06673",
    stroke: "#662D91",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_14436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.00195312)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectDetailPopulation);
export default __webpack_public_path__ + "static/media/projectDetailPopulation.fd38dbc5aaa04764784e9a2f71b78baa.svg";
export { ForwardRef as ReactComponent };